import * as zones from './list'

import { Zone } from 'app/types/park/site'

export const allZones: Zone[] = Object.values(zones).sort(
    (previous, current) => previous.priority - current.priority,
)
